import React from "react";
import classNames from "classnames";

import { BaseProps } from "@src/types/BaseProps.types";

import "./Textarea.scss";

interface TextareaProps extends BaseProps<HTMLTextAreaElement> {
  value?: HTMLTextAreaElement["value"];
  label?: string;
  htmlFor?: HTMLLabelElement["htmlFor"];
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  rows?: number;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea = ({
  value,
  label,
  htmlFor,
  placeholder = "enter value",
  disabled,
  error,
  rows = 3,
  className,
  onChange,
  ...props
}: TextareaProps) => {
  const classes = classNames("textarea", { disabled: disabled, error: error }, className);

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={htmlFor} className="textarea-label">
          {label}
        </label>
      )}

      <textarea
        rows={rows}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className="textarea-control"
        {...props}
      />

      {error && <p className="p0 warning input-error">{error}</p>}
    </div>
  );
};

export default Textarea;
